module.exports = __webpack_public_path__ + "static/media/alc-1.e5655787.jpg";